export function getAppPathnames() {
  const url = new URL(window.location.href);

  const [service, id] = url.pathname.slice(1).split('/');

  return {
    service,
    id,
  };
}
